// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerbaseBanner":"tk_a bie_b bie_bj","StrollerbaseBanner__hint":"tk_b bie_vh","StrollerbaseBanner__link":"tk_c"};